<template>
  <Modal :darker="true" :hideHeader="true" :hideButtonsContainer="true">
    <template #content>
      <Loader :withMessage="withMessage" :message="message" />
    </template>
  </Modal>
</template>

<script>
import Loader from "@/components/Utils/Loader.vue";
import Modal from "@/components/Utils/Modal.vue";
export default {
  name: "ModalLoader",
  components: { Loader, Modal },
  props: {
    message: {
      type: String,
      default: "Loading",
    },
    withMessage: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style></style>
